import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconAdobeInDesign16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconAdobeInDesign16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4 3h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1M2 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm3.405 1.75V11h.99V5.75zm2.5 5.137q.39.218.832.218.51 0 .772-.173a1.2 1.2 0 0 0 .398-.382h.135V11h.93V5.75h-.945v1.957h-.135a.9.9 0 0 0-.218-.255 1.1 1.1 0 0 0-.375-.194 1.7 1.7 0 0 0-.562-.083q-.45 0-.833.225-.382.217-.615.645T7.057 9.08v.12q0 .607.232 1.035.233.428.615.652m1.844-.885a1.02 1.02 0 0 1-.727.278q-.435 0-.728-.277-.292-.286-.292-.825v-.076q0-.54.292-.817Q8.587 8 9.022 8q.442 0 .727.285.293.277.293.817v.075q0 .54-.293.825"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconAdobeInDesign16);
